module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/buildings-blue-0c12498315621c7efe906d1963b9094c.svg";